<template>
	<v-container fluid >
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{$t('buttons.back')}}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 md12 pa-1 sm12 xl6 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row wrap>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.name"
													:label="'* '+$t('fields.accountName')"
													v-model="paymentAccount.name"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.company_name"
													:label="'* '+$t('fields.companyName')"
													v-model="paymentAccount.company_name"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.address"
													:label="'* '+$t('fields.address')"
													v-model="paymentAccount.address"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.bank"
													:label="'* '+$t('fields.bank')"
													v-model="paymentAccount.bank"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.iban"
													:label="'* '+$t('fields.iban')"
													v-model="paymentAccount.iban"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.swift"
													:label="'* '+$t('fields.swift')"
													v-model="paymentAccount.swift"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.email"
													:label="'* '+$t('fields.email')"
													v-model="paymentAccount.email"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.phone"
													:label="'* '+$t('fields.phone')"
													v-model="paymentAccount.phone"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="paymentAccountValidation.web"
													:label="'* '+$t('fields.web')"
													v-model="paymentAccount.web"></InputField>
									</v-flex>
									<v-flex xs12>
										<Dropdown
											:ajax="true"
											:data="'payment-methods'"
											:label="'* '+$t('fields.paymentMethod')"
											v-model="paymentAccount.payment_method_id"></Dropdown>
									</v-flex>
									<v-flex xs12>
										<v-img contain v-if="paymentAccount.logo.link == ''" :src="publicPath+'logo_placeholder.jpg'" :max-width="200" :max-height="200"/>
										<v-img contain v-if="paymentAccount.logo.link != ''" :src="paymentAccount.logo.link" :max-width="200" :max-height="200"/>
										<Upload :error="paymentAccountValidation.logo" :accept="'image/png, image/jpeg'" :label="'* '+$t('fields.logo')"
												v-model="paymentAccount.logo"/>
									</v-flex>
									<v-flex xs12>
										<CheckBox
											:label="$t('fields.active')"
											v-model="paymentAccount.active"></CheckBox>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField";
	import CheckBox from "./trinkets/CheckBox";
	import Upload from "./trinkets/Upload";
	import Dropdown from "./trinkets/Dropdown";

	export default {
		name: "PaymentAccount",
		components: {CheckBox, InputField, Upload, Dropdown},
		props: {
			id: Number,
			action: String
		},
		data: function () {
			return {
				publicPath: process.env.BASE_URL,
				initialLoad: false,
				paymentAccount: {
					id: this.$route.params.id,
					name: '',
					company_name: '',
					address: '',
					bank: '',
					iban: '',
					swift: '',
					email: '',
					phone: '',
					web: '',
					logo: {
						name: '',
						link: '',
						original_name: ''
					},
					active: true,
					payment_method_id: 1
				},
				paymentAccountValidation: {
					id: '',
					name: '',
					company_name: '',
					address: '',
					bank: '',
					iban: '',
					swift: '',
					email: '',
					phone: '',
					web: '',
					logo: '',
					active: ''
				},
				changesHappened: false
			}
		},
		watch: {
			paymentAccount: {
				handler: function () {
					if (this.initialLoad) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		methods: {
			backClick() {
				this.$router.go(-1);
			},
			saveClick() {
				let success = true;

				if (this.paymentAccount.name == '') {
					success = false;
					this.paymentAccountValidation.name = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.name = '';
				}

				if (this.paymentAccount.company_name == '') {
					success = false;
					this.paymentAccountValidation.company_name = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.company_name = '';
				}

				if (this.paymentAccount.address == '') {
					success = false;
					this.paymentAccountValidation.address = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.address = '';
				}

				if (this.paymentAccount.bank == '') {
					success = false;
					this.paymentAccountValidation.bank = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.bank = '';
				}

				if (this.paymentAccount.iban == '') {
					success = false;
					this.paymentAccountValidation.iban = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.iban = '';
				}

				console.log(1);
				if (this.paymentAccount.swift == '') {
					console.log(2);
					success = false;
					this.paymentAccountValidation.swift = this.$t('alerts.fieldError');
				} else {
					console.log(3);
					this.paymentAccountValidation.swift = '';
				}

				if (this.paymentAccount.email == '') {
					success = false;
					this.paymentAccountValidation.email = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.email = '';
				}

				if (this.paymentAccount.phone == '') {
					success = false;
					this.paymentAccountValidation.phone = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.phone = '';
				}

				if (this.paymentAccount.web == '') {
					success = false;
					this.paymentAccountValidation.web = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.web = '';
				}

				if (this.paymentAccount.logo.link == '') {
					success = false;
					this.paymentAccountValidation.logo = this.$t('alerts.fieldError');
				} else {
					this.paymentAccountValidation.logo = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.paymentAccount.id != 0) {
						action = 'put';
						addition = '/' + vm.paymentAccount.id;
					}
					vm.$APICall(action, 'payment-accounts' + addition, vm.paymentAccount, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.paymentAccount.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			if (this.paymentAccount.id != 0) {
				let vm = this;
				this.$APICall('get', 'payment-accounts/' + this.paymentAccount.id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.paymentAccount = usableData;
						vm.$myStore.commit('setBreadcrumbs', [
							{text: vm.$t('modules.paymentAccounts'), href: '/#/payment-accounts', disabled: false},
							{
								text: vm.paymentAccount.name,
								href: '/payment-accounts/' + vm.paymentAccount.id,
								disabled: true
							}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{text: this.$t('modules.paymentAccounts'), href: '/#/payment-accounts', disabled: false},
					{text: this.$t('modules.newPaymentAccount'), href: '/#/payment-accounts/0', disabled: true}
				]);
				this.initialLoad = true;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.changesHappened) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					next(result);
				});
			} else {
				next(true);
			}
		}
	}
</script>

<style scoped>
</style>
